const ActionTypes = {
  SET_SEASON_REGISTRATION_LINK: 'SET_SEASON_REGISTRATION_LINK'
};

function setSeasonRegistrationLink (linkData) {
  return {
    type: ActionTypes.SET_SEASON_REGISTRATION_LINK,
    data: linkData
  };
}

export { ActionTypes, setSeasonRegistrationLink };



// WEBPACK FOOTER //
// ./src/js/store/actions/seasonregistration.js